import { createBrowserInspector as _createBrowserInspector } from '@statelyai/inspect';
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import type { DevToolsPlugin } from '../../types';
import { styles } from './xstate-inspector.styles';

export function createBrowserInspector(options?: Parameters<typeof _createBrowserInspector>[0]) {
  return _createBrowserInspector({ autoStart: false, ...options });
}

@customElement('acme-devtools-xstate')
export class AcmeDevToolsXState extends LitElement {
  static override styles = styles;

  private _onInspectorsChanged = () => this.requestUpdate();

  override connectedCallback(): void {
    super.connectedCallback();
    window.addEventListener('acme:devtools-badge-update', this._onInspectorsChanged);
    this.requestUpdate();
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback();
    window.removeEventListener('acme:devtools-badge-update', this._onInspectorsChanged);
  }

  private get _devTools() {
    return (window as any).__ACME_B2B__?.devTools;
  }

  private _startInspector(key: string) {
    this._devTools?.getInspector?.(key)?.start?.();
  }

  override render() {
    const devTools = this._devTools;
    const keys: string[] = devTools?.listInspectors?.() ?? [];

    return html`
      ${!devTools
        ? html`<div class="empty">XState inspector not available.</div>`
        : keys.length === 0
          ? html`<div class="empty">No inspectors registered yet. Navigate to a page that uses an XState machine.</div>`
          : keys.map(
              (key) => html`
                <div class="inspector-row">
                  <code class="inspector-key">${key}</code>
                  <button class="start-btn" @click=${() => this._startInspector(key)}>Start</button>
                </div>
              `,
            )}
    `;
  }
}

export const xstatePlugin: DevToolsPlugin = {
  id: 'xstate',
  label: 'XState',
  tagName: 'acme-devtools-xstate',
};

declare global {
  interface HTMLElementTagNameMap {
    'acme-devtools-xstate': AcmeDevToolsXState;
  }
}
